import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button, TableCell, Grid } from "@material-ui/core";
import {ROUTE_GUEST_COMPANY_LANDING_BASE} from 'constants/routes';
import {ROUTE_DASHBOARD} from 'constants/routes';
import { EnhancedTable } from "components/Global/Table/EnhancedTable";

const StyledTableCell = styled(TableCell)`&&&& {
                                                  min-width: 275px;
                                                }`;

const SelectedNoItemGrid = styled(Grid)`&&&& {
                                              padding: 12px;
                                              background-color: rgb(242, 242, 242);
                                              font-family: "Roboto Medium", "Roboto Regular", Roboto;
                                              font-weight: 500;
                                              font-style: normal;
                                              font-size: 17px;
                                              color: rgb(153, 153, 153);
                                              width: 1500px;
                                            }`;

const NewButton = styled(Button)`&& {
                                      margin: 0 0 -4px 4px;
                                      padding: 8px 8px 0px 2px;
                                      border-radius: 0;
                                      color: #2196f3;
                                      background: none;
                                    }
                                    & span {
                                      margin-left: 4px;
                                    }
                                    &&:hover {
                                      background: #f6f6f6;
                                    }
                                  `;

export const VerticalDivider = styled.div` {
                                            height: 34px;
                                            border-right: 1px solid #cccccc;
                                           }`;

const EmptyListDiv = styled.div`&& {
                                    margin-top: 17px,
                                    margin-bottom: 17px
                                   }`;


export class GuestCompanyTable extends Component {
  tableColumns = (props) => [
    {
      id: 'contactcompanyname',
      label: 'Company',
      numeric: false,
      isString: true,
      isDateField: false,
      dataField: 'name',
      cellComponent: company =>
      (
        <div onClick={() => localStorage.setItem('guestCompanyId', company.id)}>
          <NavLink exact to={`${ROUTE_DASHBOARD}`}>
            <span>{`${company.name}`}</span>
          </NavLink>
        </div>)
    },
    {
      id: 'dealCount',
      label: 'No. of Deals',
      numeric: true,
      isString: false,
      isDateField: false,
      isNotFilterable: true,
      dataField: 'dealCount'
    },
  ];
/*      
      (<NavLink exact to={`${ROUTE_GUEST_COMPANY_LANDING_BASE}/${company.id}`}>
          <span>{`${company.name}`}</span>
      </NavLink>)
*/
  render() {
    if(!this.props.records) return null;

    if(this.props.records.length == 0) {
      return (<EmptyListDiv>
                {this.props.headerComponent}
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8} style={{paddingBottom:"8px"}}>
                  <SelectedNoItemGrid container item>{`No companies with invited deals found`}</SelectedNoItemGrid>
                </Grid>
              </EmptyListDiv>)
    } else {
      const tableColumns = this.tableColumns(this.props);
      return (<EnhancedTable
                columnDefinitions={tableColumns}
                rows={this.props.records}
                orderBy={this.tableColumns[0]}
                order={EnhancedTable.DESC_ORDER}
                shouldHideConfig={true}
                shouldHideExport={true}
                useGridLayout
                searchable
                searchHintText="Search By Company"
                width={'99%'}
                overflowY={"inherit"}                
                pageable
                rowsPerPage={10}
                tableConfigItemId="4b6c431d-67ef-4f89-9fd3-24d4e0900c20"
                />);
    }
  }
}

function mapStateToProps() {
  return {};
}

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(GuestCompanyTable);
